import script from "./VideoH5.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoH5.vue?vue&type=script&setup=true&lang=js"

import "./VideoH5.vue?vue&type=style&index=0&id=4f38804a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f38804a"]])

export default __exports__